import { Component, OnInit } from "@angular/core";
import { BaseControlComponent } from "../base-control/base-control.component";
import { ContextInteractionService } from "../../services/context-interaction.service";


@Component({
    selector: "app-radio",
    templateUrl: "./radio.component.html",
    styleUrls: ["./radio.component.scss"],
    standalone: false
})
export class RadioComponent extends BaseControlComponent implements OnInit {
    static componentName = "RadioComponent";

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {
        super.ngOnInit();

        if (!this.componentData.config.choices)
            this.componentData.config.choices = [];

        if (!this.contextValue && this.componentData.config.choices.length)
            this.contextValue = this.componentData.config.choices[0];
    }
}
